import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import useQuery, { _get } from "../../../Utils/Helper";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/reducers";
import { all_routes } from "../../../router/all_routes";

const StudentNavBar = () => {
  interface Student {
    full_name: string;
    home_address: string;
    date_of_birth: string;
    sex: string;
    student_name: string;
    mother_tongue: string;
    school_attended: string;
    class_name: string;
    l_g_a: string;
    nationality: string;
    status: string;
    blood_group: string;
    current_class?:string;
    phone:string;
    email:string;
    admission_no?:string;
  }
  const StudentData: Student = {
    full_name: "",
    home_address: "",
    date_of_birth: "",
    sex: "",
    student_name: "",
    mother_tongue: "",
    school_attended: "",
    class_name: "",
    l_g_a: "",
    nationality: "",
    status: "",
    blood_group: "",
    phone:"",
    email:"",
    admission_no:"",
  };
  // const [parent, setParent] = useState(_parent);
  // const [new_data, setNewData] = useState(_new_data);
  const q = useQuery();
  const admission_no = q.get('admission_no')
  const [student, setStudent] = useState<Student>(StudentData)
  const {user} = useSelector((state:RootState)=>state.auth)
  const [payments, setPayments] = useState([])

  useEffect(() => {
    if(user.role && user.role!=='Student'){
    _get(
      `students?query_type=select&admission_no=${admission_no}`,
      (res) => {
        setStudent(res.data[0]);
      },
      (err) => {
        console.log(err);
      }
    );
  }else{
    setStudent(user)
  }
  },[user.role]);

  return (
    <ul className="nav nav-tabs nav-tabs-bottom mb-4">
    <li>
      <Link
        to={`${all_routes.studentDetail}?admission_no=${student.admission_no}`}
        className="nav-link"
      >
        <i className="ti ti-school me-2" />
        Student Details
      </Link>
    </li>
    <li>
      <Link
        to={`${all_routes.studentTimetable}?admission_no=${admission_no}`}
        className="nav-link active"
      >
        <i className="ti ti-table-options me-2" />
        Time Table
      </Link>
    </li>
    <li>
      <Link
        to={`${all_routes.studentLeaves}?admission_no=${admission_no}`}
        className="nav-link"
      >
        <i className="ti ti-calendar-due me-2" />
        Leave &amp; Attendance
      </Link>
    </li>
    <li>
      <Link
        to={`${all_routes.studentFees}?admission_no=${admission_no}`}
        className="nav-link"
      >
        <i className="ti ti-report-money me-2" />
        Fees
      </Link>
    </li>
    <li>
      <Link
        to={`${all_routes.studentResult}?admission_no=${admission_no}`}
        className="nav-link"
      >
        <i className="ti ti-bookmark-edit me-2" />
        Exam &amp; Results
      </Link>
    </li>
    <li>
      <Link
        to={`${all_routes.studentLibrary}?admission_no=${admission_no}`}
        className="nav-link"
      >
        <i className="ti ti-books me-2" />
        Library
      </Link>
    </li>
  </ul>
  );
};

export default StudentNavBar;
